import { Translation } from '@shared/types/translation';

export const SERVICE_MANAGEMENT_MESSAGES = {
  TASK_FORM_SUBMITTED_SUCCESS: {
    english:
      'Task form submitted successfully. Your certificate will be available in Manage Certificates shortly.',
    polish:
      'Formularz zadania został przesłany. Twój certyfikat będzie wkrótce dostępny w sekcji Zarządzanie certyfikatami.',
  },
  RESCHEDULE_SUCCESS_MESSAGE: {
    english: 'Service request rescheduled successfully.',
    polish: 'Termin zgłoszenia serwisowego został zmieniony.',
  },
  TECHNICIAN_UPDATE_STATUS_PERMISSION_DENIED: {
    english:
      'You do not have permission to update the status of this Service Request',
    polish:
      'Nie masz uprawnień do aktualizacji statusu tego zgłoszenia serwisowego',
  },
} as const satisfies Record<string, Translation>;
